import type { Release } from '../releases.ts';

export default {
  version: '0.3.0',
  date: '2026-09-28',
  title: 'Production',
  summary: [
    'Sequences with a timeline, and source and sequence viewers',
    'HTML graphics templates rendered in an isolated renderer',
    'Subtitles, and frame-exact export with sidecars and lineage',
  ],
  features: [
    'Sequences with a timeline, source and sequence viewers',
    'HTML graphics templates rendered in an isolated renderer',
    'Subtitles, frame-exact export with sidecars and lineage',
  ],
  fixes: [],
} satisfies Release;
